export default __webpack_public_path__ + "static/media/pisína beton me monopanti ypercheilisi1.dbedbdce.webp";